import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AiService {

  constructor(private http: HttpClient) { }

  generatePrompt(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  askQuestion(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/question`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  analyzeRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/analyze`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  processDocsRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/processDocs`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  syncRequirement(obj) {
    return this.http.post(`${environment.apiUrl}/common/ai/requirement/sync`, obj, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }

  getBackgroundProcess(backgroundprocessid) {
    return this.http.get(`${environment.apiUrl}/common/backgroundprocess/get/${backgroundprocessid}`, {
      headers: new HttpHeaders().set('Token', localStorage.getItem('access_token') || '') 
    })
  }
}
